import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useGetRunBackgroundCheckOnBookingConfiguration() {
  return useCbhFlag(CbhFeatureFlag.RUN_BACKGROUND_CHECK_ON_BOOKING, {
    defaultValue: {
      isEnabled: false,
      checkrSdkUrl: "https://cdn.jsdelivr.net/npm/@checkr/web-sdk/dist/web-sdk.umd.js",
    },
  });
}
